import { Button, Col, Form, Row, Select, Space } from "antd";
import React, { useLayoutEffect } from "react";
import { useForm } from "react-hook-form";
import { DateField, InputAutocompleteField, InputField } from "../../../../atoms/FormElement";
import type { OwnerFilterConfig } from "../../../../../hooks/useGetOwners";
import { datePlaceholderddmmyyFormat } from "../../../BookingForm/components/utils";

type AdditionalFiltersProps = {
  dateTo?: any;
  dateFrom?: any;
  setDateTo: (v: any) => void;
  setDateFrom: (v: any) => void;
  setChequeDateTo?: (v: any) => void;
  setChequeDateFrom?: (v: any) => void;
  setPaymentRefFilter?: (v: any) => void;
  setTenantNameFilter: (v: any) => void;
  setBankRefFilter?: (v: any) => void;
  setErpInvoiceNumberFilter: (v: any) => void;
  setErpTenantIdFilter: (v: any) => void;
  setErpReceiptsFilter: (v: any) => void;
  chequeDateFrom?: any;
  chequeDateTo?: any;
  filterReset: () => void;
  onAfterFilterSubmit?: () => void;
  ownerFilterOptions?: OwnerFilterConfig[];
  onOwnerSelect?: (value: any, option?: any) => void;
  resetOwner?: any;
  ownerFilterOption?: any;
  setInvoiceNumber: (v: any) => void;
  setReceiptNoFilter: (v: string | null) => void;
  setIsCleared?: (v: any) => void;
  isCleared?: any;
  isReceiptsModuleEnabled?: boolean;
};

const AdditionalFilters: React.FC<AdditionalFiltersProps> = (props) => {
  const { control, handleSubmit, setValue, reset } = useForm({});
  const [screenSize, setScreenSize] = React.useState("");
  const clearedType = [
    { value: "cleared", label: "Cleared" },
    { value: "not_cleared", label: "Not Cleared" },
  ];

  useLayoutEffect(() => {
    const checkScreenSize = () => {
      const width = window.innerWidth;
      if (width >= 1500) {
        setScreenSize("xl");
      } else if (width >= 992) {
        setScreenSize("lg");
      } else {
        setScreenSize("smaller than lg");
      }
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const {
    setDateTo,
    setDateFrom,
    setChequeDateTo,
    setChequeDateFrom,
    setPaymentRefFilter,
    setTenantNameFilter,
    setBankRefFilter,
    setErpInvoiceNumberFilter,
    setErpTenantIdFilter,
    setErpReceiptsFilter,
    chequeDateFrom,
    chequeDateTo,
    filterReset,
    onAfterFilterSubmit,
    ownerFilterOptions,
    onOwnerSelect,
    resetOwner,
    ownerFilterOption,
    setInvoiceNumber,
    setReceiptNoFilter,
    setIsCleared,
    isCleared,
    isReceiptsModuleEnabled,
  } = props;

  const ownerField = ownerFilterOptions?.[0];

  const onFilterSubmit = (e: any) => {
    if (screenSize === "lg") {
      setDateFrom(e.dueDateFrom === "" ? null : e.dueDateFrom);
      setDateTo(e.dueDateTo === "" ? null : e.dueDateTo);
    }

    if (!isReceiptsModuleEnabled) {
      setChequeDateTo?.(e?.chequeDateTo === "" ? null : e?.chequeDateTo);
      setChequeDateFrom?.(e?.chequeDateFrom === "" ? null : e?.chequeDateFrom);
      setBankRefFilter?.(e?.bankRef === "" ? null : e?.bankRef);
      setPaymentRefFilter?.(e?.paymentRef === "" ? null : e?.paymentRef);
    }

    setTenantNameFilter(e?.tenantName === "" ? null : e?.tenantName);
    setReceiptNoFilter(e?.receiptNo === "" ? null : e?.receiptNo || null);
    setInvoiceNumber(e?.inviceNumber === "" ? null : e?.inviceNumber);
    setErpInvoiceNumberFilter(e?.erpInvoiceNumber === "" ? null : e?.erpInvoiceNumber);
    setErpTenantIdFilter(e?.erpTenantId === "" ? null : e?.erpTenantId);
    setErpReceiptsFilter(e?.erpReceipts === "" ? null : e?.erpReceipts);
    onAfterFilterSubmit?.();
  };

  const resetAllFields = () => {
    reset();
    setIsCleared?.(null);
    filterReset();
  };

  return (
    <Form layout="vertical" className="bf-main" onFinish={handleSubmit((e) => onFilterSubmit(e))}>
      <Row gutter={6}>
        {ownerField && ownerField.options.length > 0 && (
          <Col span={24}>
            <InputAutocompleteField
              initValue={ownerField.defaultValue}
              onSelect={onOwnerSelect}
              filterOption={ownerFilterOption}
              options={ownerField.options}
              fieldname={ownerField.name}
              label={ownerField.label}
              control={control}
              style={{ width: "100%" }}
              setValue={setValue}
              iProps={{ placeholder: ownerField.placeholder }}
              valueGot={resetOwner?.includes("reset") && ownerField.defaultValue}
            />
          </Col>
        )}

        {!isReceiptsModuleEnabled && (
          <>
            <Col span={12}>
              <DateField
                control={control}
                setValue={setValue}
                label="Cheque Date From"
                fieldname="chequeDateFrom"
                iProps={{
                  format: datePlaceholderddmmyyFormat,
                  placeholder: "Date From",
                }}
                valueGot={chequeDateFrom}
              />
            </Col>

            <Col span={12}>
              <DateField
                control={control}
                setValue={setValue}
                label="Cheque Date To"
                fieldname="chequeDateTo"
                iProps={{
                  format: datePlaceholderddmmyyFormat,
                  placeholder: "Date To",
                }}
                valueGot={chequeDateTo}
              />
            </Col>

            <Col span={12}>
              <InputField
                fieldname="paymentRef"
                label={"Payment Ref"}
                control={control}
                iProps={{
                  placeholder: "Payment Ref",
                }}
                initValue=""
              />
            </Col>

            <Col span={12}>
              <InputField
                fieldname="bankRef"
                label={"Bank"}
                control={control}
                iProps={{
                  placeholder: "Bank",
                }}
                initValue=""
              />
            </Col>
          </>
        )}

        <Col span={12}>
          <InputField
            fieldname="tenantName"
            label={"Tenant Name"}
            control={control}
            iProps={{
              placeholder: "Tenant Name",
            }}
            initValue=""
          />
        </Col>
        <Col span={12}>
          <InputField
            fieldname="inviceNumber"
            label={"Invoice No"}
            control={control}
            iProps={{
              placeholder: "Invoice No",
            }}
            initValue=""
          />
        </Col>
        <Col span={12}>
          <InputField
            fieldname="erpTenantId"
            label={"ERP Customer Id"}
            control={control}
            iProps={{
              placeholder: "ERP Customer Id",
            }}
            initValue=""
          />
        </Col>
        <Col span={12}>
          <InputField
            fieldname="erpReceipts"
            label={"ERP Receipt Id"}
            control={control}
            iProps={{
              placeholder: "ERP Receipt Id",
            }}
            initValue=""
          />
        </Col>
        <Col span={12}>
          <InputField
            fieldname="erpInvoiceNumber"
            label={"ERP Invoice Id"}
            control={control}
            iProps={{
              placeholder: "ERP Invoice Id",
            }}
            initValue=""
          />
        </Col>
        <Col span={12}>
          <InputField
            fieldname="receiptNo"
            label="Receipt No"
            control={control}
            iProps={{ placeholder: "Receipt No" }}
            initValue=""
          />
        </Col>
        {!isReceiptsModuleEnabled && (
          <Col span={12}>
            <Form.Item label={"Cleared Status"}>
              <Select
                className="cleared-custom-select"
                value={isCleared}
                style={{ borderRadius: "6px" }}
                onChange={(e) => setIsCleared?.(e)}
                placeholder={"Cleared Status"}
                size="large"
                options={clearedType}
              />
            </Form.Item>
          </Col>
        )}
        <Col span={24}>
          <Space style={{ position: "fixed", bottom: "10px", right: "5px" }}>
            <Button size={"small"} style={{ marginTop: "10px" }} className="ef-approve-btn" htmlType="submit">
              {"Submit"}
            </Button>

            <Button
              size={"small"}
              style={{ marginTop: "10px" }}
              onClick={() => resetAllFields()}
              className="ef-reject-btn"
              htmlType="button"
            >
              {"Reset"}
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
};

export default React.memo(AdditionalFilters);
